$(document).ready(function () {
  $(document).on('click', '.clients-momentum-planning-territories-component .radio-buttons__option', function () {
    const component = $(this).closest('.clients-momentum-planning-territories-component'); // Update yes-no radio button values back to section
    const id = component.attr('momentum_territories_section_id'); // Id of the section
    const property = $(this).attr('attr'); // Which radio is getting clicked
    const value = $(this).attr('value'); // Value of the radio button
    updateTerritoriesSection(id, property, value);
  });

  // UPDATE TEXT INPUT VALUES
  $(document).on('keyup', '.clients-momentum-planning-territories-component .input-text-box-js input', function () {
    const component = $(this).closest('.clients-momentum-planning-territories-component');
    const id = component.attr('momentum_territories_section_id');
    const property = $(this).attr('attr');
    const value = $(this).val();

    // Clear any existing timeout
    clearTimeout($(this).data('timeout'));

    // Set a timeout to update the value after 2 seconds
    $(this).data('timeout', setTimeout(function () {
      updateTerritoriesSection(id, property, value);
    }, 1000));
  });

  function updateTerritoriesSection(id, property, value) {
    $.post('/components/clients/momentum_sections/territories', {
      id: id,
      property: property,
      value: value
    }).done(function (data) {

      if (data.success) {
        window.reloadConfirmationDayReadinessAssessmentComponent();
        window.reloadMomentumSectionPlanningTab(data.section_completion_percentage, 'territories');
        window.reloadClientTaskBinComponents();
      }
    });
  }
});
